/**
 * Constantes de Phase 3 (preaprobación, citas, estatus).
 * TODO: Alinear enums con Backend cuando el contrato de status mande toda la info.
 */

export const DIGITAL_LOAN_PHASE3_BACKEND = Object.freeze({
  PHASE: 'PHASE_3_GESTORIA',
  STEP_SCHEDULING: 'SCHEDULING',
  STATUS_IN_PROGRESS: 'IN_PROGRESS',
});

export const LOCAL_VISIT_STATUS = Object.freeze({
  SCHEDULED: 'SCHEDULED',
  RESCHEDULED: 'RESCHEDULED',
  CANCELLED: 'CANCELLED',
});

export const DEFAULT_MAX_RESCHEDULES = 2;

export const RESCHEDULE_BUSINESS_DAYS = 7;

export const VISIT_MODIFY_CUTOFF_HOURS = 24;

export const PHASE3_SNAPSHOT_STORAGE_KEY = 'digitalLoanPhase3Snapshot';
